export default __webpack_public_path__ + "static/dialysis-clinic-ca6f1ec3d4df1796c1d0f22e17a0c816.svg";